import { Textbox } from '@openhouse-engineers/rrc'
import { Picker } from 'emoji-mart'
import React, { useEffect, useState } from 'react'

import Text from 'components/common/Text'

import ChatMessages from './Messages'
import {
    Wrapper,
    Header,
    Body,
    Cross,
    Footer,
    EmjoiBtn,
    InputGroup,
    SendBtn,
} from './styles'

import { useChatContext } from '../../context'

const crossBtnProps = {
    src: 'assets/revamp/cross.dark.svg',
    alt: 'cross-btn',
}

const emojiBtnProps = {
    src: 'assets/revamp/chat-emoji.svg',
    alt: 'emoji-btn',
}

const ENTER = 'Enter'
const CHAT_ID = 'chat-input'

const Chat = ({ isChatOpen, close }) => {
    const { chatRef, message, sendMessage, setMessage } = useChatContext()

    const [showEmojiMart, setShowEmojiMart] = useState(false)
    const toggleEmojiMart = () => setShowEmojiMart(!showEmojiMart)
    const selectEmoji = emoji => setMessage(`${message} ${emoji.native} `)

    const handleChange = e => setMessage(e.target.value)
    const handleKeyPress = e => e.key === ENTER && sendMessage()

    /* focus on chat input when it opens */
    useEffect(() => {
        const chatElem = document.getElementById(CHAT_ID)
        if (chatElem) chatElem.focus()
    }, [isChatOpen])

    return (
        <Wrapper ref={chatRef} visible={isChatOpen}>
            <Header>
                <Text level="3" color="#000008cc">
                    Chat
                </Text>
                <Cross {...crossBtnProps} onClick={close} />
            </Header>
            <Body showEmojiMart={showEmojiMart}>
                {showEmojiMart ? (
                    <Picker onSelect={selectEmoji} />
                ) : (
                    <ChatMessages />
                )}
            </Body>
            <Footer>
                <EmjoiBtn {...emojiBtnProps} onClick={toggleEmojiMart} />
                <InputGroup>
                    <Textbox
                        id={CHAT_ID}
                        value={message}
                        onChange={handleChange}
                        onKeyPress={handleKeyPress}
                        autoComplete="off"
                    />
                    {message && <SendBtn onClick={sendMessage} />}
                </InputGroup>
            </Footer>
        </Wrapper>
    )
}

export default Chat
